module.exports = __webpack_public_path__ + "img/get-pocket.937a6cd4.svg";